import axios from ".";

export const getTitleTemplatePatterns = async () => {
  return axios.get(`/multiagents/title-template-patterns`);
};

export const determineTitle = async ({ job_id }: { job_id: string }) => {
  return axios.post(`/multiagents/determine-title`, { job_id });
};

export const generateDescription = async ({ job_id, description_type }: { job_id: string; description_type: string }) => {
  return axios.post(`/multiagents/determine-editorial-description`, { job_id, description_type });
};
